import { graphql } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import slider from '../assets/images/slider.png';
import Layout from '../components/Layout';
import Navbar from '../components/Navbar/Navbar';
import generateNav from '../utils/generateNav';

const MainStyles = styled.main`
  .slider {
    margin: 15px;
    .image-container {
      background-image: url(${slider});
      background-size: contain;
      border-radius: 8px;
      width: 100%;
      height: 300px;
    }
  }
`;

export default function Home({ data }) {
  const navData = generateNav(data.brands.edges, data.devices.edges);

  return (
    <Layout>
      <Navbar navData={navData} />
      <MainStyles>
        <div className='slider'>
          <div className='image-container' />
        </div>
        <div className='content'>
          {/* eslint-disable-next-line react/no-danger */}
          <div
            dangerouslySetInnerHTML={{
              __html: data.homePage.childMarkdownRemark.html,
            }}
          />
          {/* eslint-disable-next-line react/no-danger */}
        </div>
      </MainStyles>
    </Layout>
  );
}

export const pageQuery = graphql`
  query {
    brands: allFile(
      filter: { sourceInstanceName: { eq: "brands" }, extension: { eq: "md" } }
    ) {
      edges {
        node {
          sourceInstanceName
          childMarkdownRemark {
            frontmatter {
              title
              slug
            }
          }
        }
      }
    }
    devices: allFile(
      filter: { sourceInstanceName: { eq: "devices" }, extension: { eq: "md" } }
    ) {
      edges {
        node {
          sourceInstanceName
          childMarkdownRemark {
            frontmatter {
              title
              slug
              brand
            }
          }
        }
      }
    }

    homePage: file(sourceInstanceName: { eq: "home" }) {
      id
      childMarkdownRemark {
        html
      }
    }
  }
`;
